type Props = {
  icon: string;
  label: string;
  value: string;
  helper?: string;
  tone?: 'green' | 'orange' | 'blue' | 'neutral';
};

export function MetricCard({ icon, label, value, helper, tone = 'neutral' }: Props) {
  return (
    <article className={`metric-card metric-card--${tone}`}>
      <div className="metric-card__icon" aria-hidden="true">{icon}</div>
      <div>
        <small>{label}</small>
        <strong>{value}</strong>
        {helper && <span>{helper}</span>}
      </div>
    </article>
  );
}
